const serviceTypeLabels = {
  installation: {
    key: 'Instalación',
    label: 'Instalación'
  },
  maintenance: {
    key: 'Mantenimiento',
    label: 'Mantenimiento'
  },
  repair: {
    key: 'Reparación',
    label: 'Reparación'
  },
  homeProgram: {
    key: 'Home Program',
    label: 'Home Program'
  },
  workshopRepairs: {
    key: 'Reparaciones en Taller',
    label: 'Reparaciones en Taller'
  },
  deliveries: {
    key: 'Entregas/Despachos',
    label: 'Entregas/Despachos'
  },
  maintenancePolicy: {
    key: 'Póliza de Mantenimiento',
    label: 'Póliza de Mantenimiento'
  }
}

export default serviceTypeLabels
